module.exports = __webpack_public_path__ + "static/flags/TK-6ca2c7419810c4718a71138c2e43ad57.gif";